// Version centralisée de l'application
// Ce fichier est la source unique de vérité pour la version du logiciel
// Utilisé par: environment files, app.component.ts, notif.interceptor.ts

export const APP_VERSION = '2.0.87';

